module.exports = {"TXTCLI_Cash_Out_1":{"id":"TXTCLI_Cash_Out_1","defaultMessage":"Retirar en efectivo","track":"Cash Out"}}